import React from 'react'
import {
  Adjustments,
  BundledFavorite,
  CallBlocking,
  CallFlow,
  AiReceptionist,
  Carriers,
  Device,
  ClinicInformation,
  Discounts,
  Membership,
  FeeSchedules,
  Integrations,
  PhoneManagement,
  Permissions,
  ChartingPreferences,
  Procedures,
  RoomOperatories,
  Scheduler,
  SettingsPlaceholder,
  StaffList,
  TaxLegal,
  OpeningHours,
  WorkSchedule,
  CallRecording,
  Messaging,
  AnalyticsDashboard,
  AnalyticsGoals,
  SystemAppearance,
  SystemBackup,
  SystemCloudStorage,
  Fax,
  Email,
  DicomCapture,
  PatientFormGroups,
} from '@components/pages/Settings'
import { getSettingsRouteById } from './settingsRoutes'
import SettingsSubpageGate from './SettingsSubpageGate.component'

interface SettingsRouteContentProps {
  itemId: string
}

const SettingsRouteContent = ({
  itemId,
}: SettingsRouteContentProps): React.ReactElement => {
  let page: React.ReactElement
  switch (itemId) {
    case 'comm-phone-management':
      page = <PhoneManagement />
      break
    case 'comm-call-flow':
      page = <CallFlow />
      break
    case 'comm-ai-receptionist':
      page = <AiReceptionist />
      break
    case 'comm-call-block':
      page = <CallBlocking />
      break
    case 'comm-call-record':
      page = <CallRecording />
      break
    case 'comm-messaging':
      page = <Messaging />
      break
    case 'comm-devices':
      page = <Device />
      break
    case 'comm-fax':
      page = <Fax />
      break
    case 'comm-email':
      page = <Email />
      break
    case 'practice-clinic-info':
      page = <ClinicInformation />
      break
    case 'practice-tax-and-legal':
      page = <TaxLegal />
      break
    case 'practice-opening-hours':
      page = <OpeningHours />
      break
    case 'clinical-dicom-capture':
      page = <DicomCapture />
      break
    case 'clinical-patient-form-groups':
      page = <PatientFormGroups />
      break
    case 'accounting-discounts':
      page = <Discounts />
      break
    case 'accounting-membership':
      page = <Membership />
      break
    case 'accounting-adjustments':
      page = <Adjustments />
      break
    case 'accounting-integrations':
      page = <Integrations />
      break
    case 'staff-list':
      page = <StaffList />
      break
    case 'staff-work-sched':
      page = <WorkSchedule />
      break
    case 'staff-permissions':
      page = <Permissions />
      break
    case 'clinical-charting-preference':
      page = <ChartingPreferences />
      break
    case 'reporting-dashboard':
      page = <AnalyticsDashboard />
      break
    case 'reporting-goals':
      page = <AnalyticsGoals />
      break
    case 'system-backup':
      page = <SystemBackup />
      break
    case 'system-cloud-storage':
      page = <SystemCloudStorage />
      break
    case 'system-appearance':
      page = <SystemAppearance />
      break
    case 'practice-room-operatories':
      page = <RoomOperatories />
      break
    case 'clinical-procedure':
      page = <Procedures />
      break
    case 'clinical-bundled-procedures':
      page = <BundledFavorite />
      break
    case 'accounting-carrier':
      page = <Carriers />
      break
    case 'accounting-fee-schedule':
      page = <FeeSchedules />
      break
    case 'practice-scheduler':
      page = <Scheduler />
      break
    default:
      page = (
        <SettingsPlaceholder
          title={getSettingsRouteById(itemId)?.name ?? 'Settings'}
        />
      )
  }

  return <SettingsSubpageGate pageKey={itemId}>{page}</SettingsSubpageGate>
}

export default SettingsRouteContent
